import { useCallback, useRef, useState } from 'react';
import { getUsersByRole } from 'services/userService';

export function useUsersByRole() {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const abortControllerRef = useRef(null);

  const fetchUsersByRole = useCallback(async (roleId, searchText = '') => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    const controller = new AbortController();
    abortControllerRef.current = controller;

    setIsLoading(true);
    setError(null);

    try {
      const result = await getUsersByRole(
        roleId,
        searchText,
        controller.signal
      );

      setData(result);
      return result;
    } catch (err) {
      if (err.name === 'CanceledError' || err.name === 'AbortError') {
        return;
      }

      setError(err);
      throw err;
    } finally {
      setIsLoading(false);
    }
  }, []);

  return { data, isLoading, error, fetchUsersByRole };
}
